import wcs from '@/scripts/libs/wcs/index'
import axios from 'axios'
import { N } from '@/scripts/constants/booleans'
import { WcsCart } from './cart'

const { storeId, catalogId, langId, earlyAccess } = wcs.getStoreConfig()

export class WcsEarlyAccess {
  static callEarlyAccess = async (orderId: number, callback: () => void) => {
    await WcsCart.getMinicart()
    const urlEarlyAccess = earlyAccess.url?.replace('{storeId}', storeId)
    const removeToCartUrl = wcs.getEndPoint('removeToCart')
    await axios.get(urlEarlyAccess)
    sessionStorage.setItem('eaactivitydone', 'true')
    await callback()
    if (orderId) {
      await axios.get(removeToCartUrl, {
        params: {
          catalogId: catalogId,
          storeId: storeId,
          langId: langId,
          doInventory: N,
          quantity: 0,
          orderId,
        },
      })
    }
  }
}
